import { useNavigate } from "react-router-dom";
import { POPUP_CLOSE_TIME } from "../../../../constant/constant";
import { useDeleteLesson } from "../../../../hooks/teacher/lessons/useDeleteLesson";
import DeleteModal from "../../../common/DeleteModal";
import { useState } from "react";
/**
 * @typedef {import("../../../../hooks/teacher/lessons/useGetAllLessons").LessonDataType} LessonDataType
 */

/**
 * @param {{lesson: LessonDataType,refetch:()=> void, disabled: boolean, type: "Teacher" | "School" }} param
 */
const LessonTableRow = ({ lesson, refetch, disabled, type }) => {
  const [deleteModal, setDeleteModal] = useState(false);
  const { deleteLesson, loading, error, success } = useDeleteLesson();
  const navigate = useNavigate();

  const handleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };

  const handleDelete = async () => {
    await deleteLesson({
      lessonId: lesson?.id,
      onSuccess: () => {
        setTimeout(() => {
          setDeleteModal(false);
          refetch();
        }, POPUP_CLOSE_TIME);
      },
    });
  };

  const handleEdit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (type === "Teacher") {
      navigate(`/teacher/lesson/update/${lesson?.id}`);
    } else {
      navigate(
        `/school-admin/lesson/update/${lesson?.id}/${lesson?.creator?.id}`,
      );
    }
  };

  return (
    <>
      <tr>
        <td>{lesson?.title}</td>
        <td>{lesson?.description}</td>
        <td>{lesson?.quest_count}</td>
        <td>{lesson?.classroom_count}</td>
        <td className="d-flex gap-2">
          <button
            className=""
            disabled={disabled}
            onClick={handleEdit}
            style={{
              backgroundColor: "black",
              color: "white",
              border: "none",
              padding: "5px 20px",
              borderRadius: "5px",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            Edit
          </button>
          <button
            className="action-delete-edit-btn"
            onClick={handleDeleteModal}
            disabled={disabled}
          >
            <i className="bi bi-trash"></i>
          </button>
        </td>
      </tr>
      <DeleteModal
        message="Are you sure you want to delete this lesson?"
        showModal={deleteModal}
        handleClose={handleDeleteModal}
        handleDelete={handleDelete}
        loading={loading}
        errorMessage={error}
        successMessage="Lesson deleted successfully"
        success={success}
      />
    </>
  );
};

export default LessonTableRow;
